const getAmenabilityColumnGroups = () => [
  {
    id: 'positive',
    name: 'ESI+ amenable',
    hideInSelect: true,
  },
  {
    id: 'positive_proba',
    name: 'ESI+ amenable confidence',
    hideInSelect: true,
  },
  {
    id: 'negative',
    name: 'ESI- amenable',
    hideInSelect: true,
  },
  {
    id: 'negative_proba',
    name: 'ESI- amenable confidence',
    hideInSelect: true,
  },
]

export { getAmenabilityColumnGroups }
